import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.RejectedPage', {
    pageTitle: 'Wallets - Onboarding | {companyName} | Rejected',
    title: 'Unfortunately, your application has been rejected',
    unableToApprove:
        'After reviewing your application details, we were unable to approve your application at this time.',
    reasonsOfDenial: `Applications may be denied due to incomplete documentation, verification issues, or other criteria not being met.
        If you believe this was a mistake, our support team is here to help.`,
});
